import React from 'react';
import QuadProd from './QuadProd';
import { ProjetosDB } from '../ProjetosDB';

function Projects() {
  return (
    <section className="services">
            <div className="container">
                <div className="row">
                    <h2>Projetos</h2>
                    
                    {
                        ProjetosDB.map((user, i) => {
                        return (
                            <QuadProd  
                            key={i} 
                            titulo={ProjetosDB[i].titulo} 
                            meio={ProjetosDB[i].meio}
                            link={ProjetosDB[i].link} 
                            data={ProjetosDB[i].data} 
                            text1={ProjetosDB[i].text1} 
                            text2={ProjetosDB[i].text2} 
                            icon={ProjetosDB[i].icon}
                            status={ProjetosDB[i].status}
                            />
                            );
                        })
                    }

                </div>
              </div>
    </section>
    

  );
}

export default Projects;